import moment from 'moment';

export const amonutFormatter = (number) => {
  if (number > 10000000) {
    return (number / 10000000).toString() + 'Cr';
  } else if (number > 100000) {
    return (number / 100000).toString() + 'L';
  } else if (number > 1000) {
    return (number / 1000).toString() + 'K';
  } else {
    return number.toString();
  }
};

const defaultCurrency = 'inr';

export const dataFormatter = (value, format) => {
  switch (format) {
    case 'currency':
      return Intl.NumberFormat('en-IN', {
        currency: defaultCurrency,
        minimumFractionDigits: 0,
        style: 'currency',
      }).format(value);
    case 'date-short':
      return moment(value).format('MMM D');
    case 'date-full':
      return moment(value).format('MMMM DD YYYY');
    case 'amount-short':
      return amonutFormatter(value);
    case 'number':
      return Intl.NumberFormat('en-IN', {
        minimumFractionDigits: 0,
      }).format(value);
    default:
      return value;
  }
};
